import api from './api';

export default {
  getCompanyBranding
};

async function getCompanyBranding({ commit }) {
  try {
    const result = await api.getCompanyBranding();
    if (result) {
      commit('SET_COMPANY_BRANDING', result);
    }
    return result;
  } catch (e) {
    console.error('[VUEX ACTION] Failed to get company branding:', e);
  }
}
